module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B12VZPZ.a50c466c.jpg";